import React from "react";
import { Link } from "react-router-dom";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div className="about-us-main-div">
      <div className="about-us-content">
        <h1 className="about-us-title">Coming Soon</h1>
        <p className="about-us-text">
          We're working hard on this page. Check back soon for more information
          about Seattle Vegans!
        </p>
        <Link to="/" className="about-us-home-button">
          Take Me Home
        </Link>
      </div>
      <div className="buffer" />
    </div>
  );
};

export default AboutUs;
